/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CsvPreferencesDtoBase
 * auto generated base class for the model CsvPreferencesDtoModel.
 */
export const CsvPreferencesDtoModelBase = ModelBase
  .named('CsvPreferencesDto')
  .props({
    __typename: types.optional(types.literal("CsvPreferencesDto"), "CsvPreferencesDto"),
    newKeys: types.union(types.undefined, types.array(types.string)),
    mapping: types.union(types.undefined, types.frozen()),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CsvPreferencesDtoModelSelector extends QueryBuilder {
  get newKeys() { return this.__attr(`newKeys`) }
  get mapping() { return this.__attr(`mapping`) }
}
export function selectFromCsvPreferencesDto() {
  return new CsvPreferencesDtoModelSelector()
}

export const csvPreferencesDtoModelPrimitives = selectFromCsvPreferencesDto().newKeys.mapping
